
import Typewriter from "typewriter-effect";

export default function TypewriterEffect(props) {
    const { statements } = props;
    return (
        <Typewriter
            options={{
                strings: statements,
                delay: 'natural',
                deleteSpeed: 'natural',
                autoStart: true,
                loop: false,
                changeDelay: 500
            }}
        />
    )
};
